import { useEffect } from "react";
import Home from "./components/home";
import Offer from "./components/offer";
import Privacy from "./components/privacy-policy";
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import ProgrammPage from "./components/programm";
import Сongratulation from "./components/congratulations";

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    const maxAttempts = 20;
    const headerOffset = 80;

    const scrollToElement = (element, behavior = "auto") => {
      const top = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top, behavior });
    };

    const tryScroll = () => {
      const element = document.getElementById(id);

      if (element) {
        scrollToElement(element, "smooth");

        // Correct final position after async content/images change the document height.
        [350, 800, 1500].forEach((delay) => {
          window.setTimeout(() => {
            const currentElement = document.getElementById(id);
            if (currentElement) {
              scrollToElement(currentElement, "auto");
            }
          }, delay);
        });

        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        window.setTimeout(tryScroll, 100);
      }
    };

    tryScroll();
  }, [hash, pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
        <BrowserRouter>
          <ScrollToHash />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/programm" element={<ProgrammPage />} />
                <Route path="/offer" element={<Offer />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/congratulations" element={<Сongratulation />} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
